import { Component, OnInit } from "@angular/core";
import {
  Store,
  WorkoutsState,
  AutoUnsubscribe,
  Subscription,
  Fields,
  Types,
  combineLatest,
  TGSFormControl,
} from "../store";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WorkoutService, AlertService } from "../../../services";
import { InjuryService } from "../../../services/injury.service ";
import { AmChart, AmChartsService } from "@amcharts/amcharts3-angular";
import * as lodash from "lodash";

@Component({
  selector: "app-club-all-injuries",
  templateUrl: "./club-all-injuries.component.html",
  styleUrls: ["./club-all-injuries.component.css"],
})
@AutoUnsubscribe
export class ClubAllInjuriesComponent implements OnInit {
  sub: Subscription;
  plan = null;
  workoutPlanID: number;
  firstTeamPlayers: any;
  firstTeamPlayersCopy: any;

  selectedWorkout = null;
  formOpened: boolean;

  confirmOpened: boolean;
  public links: { title: string; url: any }[] = [];

  public isMonthlyInjuryChartLoaded: boolean = false;
  private chartData: any;
  private chart: AmChart;

  public isLoadChartDataByClubID = false;
  public isLoadAllInjuredPlayersByClubID = false;

  public clubID: number;
  config: any;
  p: number;

  searchPayload = {
    firstName: "",
    lastName: "",
    injuryStatus: "",
    teamGender: "",
    teamID: "",
  };

  constructor(
    private store: Store<WorkoutsState>,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: Ng4LoadingSpinnerService,
    private _service: InjuryService,
    private as: AlertService,
    private AmCharts: AmChartsService
  ) {}

  ngOnInit() {
    this.clubID = +localStorage.getItem("clubId");
    // console.log("CLUB ID => ", clubID);

    this.isLoadChartDataByClubID = false;
    this.isLoadAllInjuredPlayersByClubID = false;

    this.spinner.show();

    this.loadAllInjuredPlayersByClubID(this.clubID);
    this.loadChartDataByClubID(this.clubID);

    this.links = [{ title: "CLUB TEAMS PLAYER LIST", url: null }];
  }

  loadChartDataByClubID(clubID: number) {
    this._service.loadAllChartDataByClubID(clubID).subscribe(
      (result) => {
        console.log("loadAllChartDataByClubID =====> ", result);
        this.chartData = result;
        this.isLoadChartDataByClubID = true;
        this.generateReportGraph();
        this.hideSpinnerCheck();
      },
      (error) => {
        this.isLoadChartDataByClubID = true;
        this.hideSpinnerCheck();
      }
    );
  }

  loadAllInjuredPlayersByClubID(clubID: number) {
    this._service.loadAllInjuredPlayersByClubID(clubID).subscribe(
      (result: any) => {
        console.log("result  => ", result);
        this.firstTeamPlayers = result;
        this.firstTeamPlayersCopy = result;

        this.isMonthlyInjuryChartLoaded = true;
        this.isLoadAllInjuredPlayersByClubID = true;
        this.loadPaginationConfig();
        this.hideSpinnerCheck();
      },
      (error) => {
        this.isLoadAllInjuredPlayersByClubID = true;
        console.log("Could not load all injuries");
        this.hideSpinnerCheck();
      }
    );
  }
  loadPaginationConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.firstTeamPlayers.length,
    };
  }

  hideSpinnerCheck() {
    if (
      this.isLoadChartDataByClubID == true &&
      this.isLoadAllInjuredPlayersByClubID == true
    ) {
      this.spinner.hide();
    }
  }

  public itemsPerPage = 10;
  public reverse = false;
  public sortValue = "lastName"; // Default Sorting Value

  setOrder(value: string) {
    this.reverse = !this.reverse;
    this.sortValue = value;
    const transacations = lodash.sortBy(this.firstTeamPlayers, value);
    this.firstTeamPlayers = this.reverse
      ? transacations.reverse()
      : transacations;
  }

  public isShowPlayerSearch: boolean = false;
  onPlayerSearch() {
    this.isShowPlayerSearch = true;
  }

  searchPlayer() {
    this.firstTeamPlayers = this.firstTeamPlayersCopy;
    console.log(this.searchPayload);
    console.log(this.firstTeamPlayers);

    if (this.searchPayload.firstName !== "") {
      this.firstTeamPlayers = this.firstTeamPlayers.filter(
        (item) =>
          item.playerFirstName
            .toLowerCase()
            .indexOf(this.searchPayload.firstName.toLowerCase()) > -1
      );
    }

    if (this.searchPayload.lastName !== "") {
      this.firstTeamPlayers = this.firstTeamPlayers.filter(
        (item) =>
          item.playerLastName
            .toLowerCase()
            .indexOf(this.searchPayload.lastName.toLowerCase()) > -1
      );
    }

    if (this.searchPayload.injuryStatus !== "") {
      this.firstTeamPlayers = this.firstTeamPlayers.filter((n) =>
        n.currentStatus.toString().indexOf(this.searchPayload.injuryStatus) > -1
      );
    }

    if (this.searchPayload.teamID !== "") {
      this.firstTeamPlayers = this.firstTeamPlayers.filter((n) =>
        n.teamID.toString().indexOf(this.searchPayload.teamID) > -1
      );
    }
  }

  resetSearchPlayer() {
    this.searchPayload.firstName = "";
    this.searchPayload.lastName = "";
    this.searchPayload.injuryStatus = "";
    this.searchPayload.teamGender = "";
    this.searchPayload.teamID = "";
    this.teamList.length = 0;
    this.firstTeamPlayers = this.firstTeamPlayersCopy;
  }

  public teamList = [];
  loadTeamsByGender(event){
    console.log("loadTeamsByGender  => ", event.target.value);
    if(event.target.value){
      this.spinner.show();
      this._service.loadTeamsByGenderAndClubID(this.clubID, event.target.value).subscribe(result => {
        this.teamList = result;
        this.spinner.hide();
      }, error => {
        this.teamList.length = 0;
        this.spinner.hide();
      })
    } else {
      this.teamList.length = 0;
      this.searchPayload.teamID = '';
    }
    
  }

  generateReportGraph() {
    this.chart = this.AmCharts.makeChart("chartdiv", {
      type: "serial",
      startDuration: 1,
      theme: "none",
      legend: {
        horizontalGap: 10,
        maxColumns: 1,
        position: "right",
        useGraphSettings: true,
        markerSize: 10,
      },
      dataProvider: this.chartData,
      valueAxes: [
        {
          stackType: "regular",
          axisAlpha: 0.3,
          gridAlpha: 0,
        },
      ],
      graphs: [
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Healthy",
          type: "column",
          color: "black",
          fillColors: "#6cbceb",
          valueField: "healthy",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Day To Day",
          type: "column",
          color: "black",
          fillColors: "#8bddd6",
          valueField: "daytoday",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "In Therapy",
          type: "column",
          color: "black",
          fillColors: "#668e8c",
          valueField: "intherapy",
        },
        {
          balloonText:
            "<b>[[title]]</b><br><span style='font-size:14px'>[[category]]: <b>[[value]]</b></span>",
          fillAlphas: 0.8,
          labelText: "[[value]]",
          lineAlpha: 0.3,
          title: "Injured",
          type: "column",
          color: "black",
          fillColors: "#9f9fa0",
          valueField: "injured",
        },
      ],
      categoryField: "month",
      categoryAxis: {
        gridPosition: "start",
        axisAlpha: 0,
        gridAlpha: 0,
        position: "left",
      },
      export: {
        enabled: true,
      },
    });
  }

  showPlayerInjuries(player) {
    console.log("showPlayerInjuries ==> ", player);
    this.router.navigate([
      "club-injury/club-player-injuries/" +
        player.teamID +
        "/" +
        player.playerID,
    ]);
  }

  closeOverlay(event = null) {
    this.isShowPlayerSearch = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/club-injuries-list/club-all-injuries.component.ts